import React from 'react';

import './IconButton.scss';

export const IconButton = (props) => {
  return (
    <button className="icon-button" onClick={props.onClick}>
      {props.icon()}
      <label className="">{props.text}</label>
    </button>
  );
};
